/**
 * Port of Pages/Shared/_PaginationPartial.cshtml - hidden below two pages, and shows a
 * five-page window centred on the current page.
 */
interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ page, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const first = Math.max(1, page - 2);
  const last = Math.min(totalPages, page + 2);
  const pages: number[] = [];
  for (let i = first; i <= last; i++) pages.push(i);

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination pagination-sm justify-content-center mb-0">
        <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
          <button type="button" className="page-link" onClick={() => onPageChange(page - 1)}>
            Previous
          </button>
        </li>
        {pages.map((i) => (
          <li key={i} className={`page-item ${i === page ? 'active' : ''}`}>
            <button type="button" className="page-link" onClick={() => onPageChange(i)}>
              {i}
            </button>
          </li>
        ))}
        <li className={`page-item ${page >= totalPages ? 'disabled' : ''}`}>
          <button type="button" className="page-link" onClick={() => onPageChange(page + 1)}>
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
}
